export function useAuth() {
  const security = useProperty<App.Auth.Data.SecurityData>('security');

  const isUser = (
    user:
      | App.Auth.Data.UserData
      | App.Auth.Data.ParentUserData
      | App.Auth.Data.StudentUserData
      | null
  ): user is App.Auth.Data.UserData => {
    return user?.model === 'user';
  };

  const isStudentParent = (
    user:
      | App.Auth.Data.UserData
      | App.Auth.Data.ParentUserData
      | App.Auth.Data.StudentUserData
      | null
  ): user is App.Auth.Data.ParentUserData | App.Auth.Data.StudentUserData => {
    return user?.model === 'student_parent' || user?.model === 'student';
  };

  const permissions = computed(() => security.value?.permissions ?? []);
  const user = computed(() => (isUser(security.value?.user) ? security.value?.user : null));
  const studentParentUser = computed(() =>
    isStudentParent(security.value?.user) ? security.value?.user : null
  );

  function hasPermission(permission: App.Auth.Enums.Permission) {
    return permissions.value.includes(permission);
  }

  function hasAnyPermission(permissions: App.Auth.Enums.Permission[]) {
    return permissions.some((permission) => hasPermission(permission));
  }

  return {
    hasAnyPermission,
    hasPermission,
    permissions,
    user,
    studentParentUser
  };
}
